import React from "react";
import { __t } from "@core/translation/translation";
import MarketDropDown from "@features/PopOverComponents/Market/MarketDropDown";
import SupportComponent from "@features/PopOverComponents/Support/SupportComponent";
import HelpComponent from "@features/PopOverComponents/Help/HelpComponent";

const headerItems1 = [
  {
    title: __t("Market"),
    path: "/market",
    icon: "icon-chevron-down",
    closeIcon: "icon-x",
    iconImage: "icon-stock-market",
    popOverComponent: MarketDropDown,
    id: 0,
  },
  {
    title: __t("Market Order"),
    path: "/marketOrder",
    icon: null,
    closeIcon: null,
    iconImage: null,
    popOverComponent: null,
    id: 1,
  },
  {
    title: __t("Support"),
    path: "/support",
    icon: "icon-chevron-down",
    closeIcon: "icon-x",
    iconImage: null,
    popOverComponent: SupportComponent,
    id: 2,
  },
  {
    title: __t("Fibitex Guide"),
    path: "/help",
    icon: "icon-chevron-down",
    closeIcon: "icon-x",
    iconImage: null,
    popOverComponent: HelpComponent ,
    id: 3,
  },
];

const headerItems2 = [
  {
    title: __t("Fees"),
    path: "/fees",
    icon: null,
  },
  {
    title: __t("Blog"),
    path: "/blog",
    icon: null,
  },
  {
    title: __t("Rules"),
    path: "/rules",
    icon: null,
  },
  {
    title: __t("About Us"),
    path: "/about us",
    icon: null,
  },
  {
    title: __t("Contact Us"),
    path: "/contactUs",
    icon: null,
  },
];

export { headerItems1, headerItems2 };
